import { ArrowLeftIcon, ArrowRightIcon } from "@phosphor-icons/react/dist/ssr";
import React from "react";
import { Link } from "zudoku/components";
import { stepHref, tutorialSteps } from "./data.js";

interface TutorialPagerProps {
  build: string;
  method: string;
  step: string;
}

/** Keep step navigation within the selected workflow. */
export function TutorialPager({ build, method, step }: TutorialPagerProps) {
  const steps = tutorialSteps(build, method);
  const index = steps?.findIndex((item) => item.slug === step) ?? -1;

  if (!steps || index < 0) {
    throw new Error(`Unknown tutorial step: ${build}/${method}/${step}`);
  }

  const previous = steps[index - 1];
  const next = steps[index + 1];

  return (
    <nav
      aria-label="Tutorial steps"
      className={`not-prose mt-12 flex flex-wrap gap-2 border-t border-border pt-6 text-muted-foreground ${previous ? "justify-between" : "justify-end"}`}
      data-pagefind-ignore="all"
    >
      {previous ? (
        <Link
          to={stepHref(build, method, previous.slug)}
          viewTransition
          aria-label={`Previous step: ${previous.title}`}
          className="inline-flex min-w-0 items-center gap-2 rounded-lg px-4 py-3 font-semibold no-underline transition-colors hover:bg-muted hover:text-foreground"
        >
          <ArrowLeftIcon size={16} aria-hidden="true" />
          <span>{previous.title}</span>
        </Link>
      ) : null}
      {next && (
        <Link
          to={stepHref(build, method, next.slug)}
          viewTransition
          aria-label={`Next step: ${next.title}`}
          className="inline-flex min-w-0 items-center gap-2 rounded-lg px-4 py-3 font-semibold no-underline transition-colors hover:bg-muted hover:text-foreground"
        >
          <span>{next.title}</span>
          <ArrowRightIcon size={16} aria-hidden="true" />
        </Link>
      )}
    </nav>
  );
}
